export const domain = 'OverwatchModel'

export const onCreateOverwatchView = `${domain}/onCreateOverwatchView`
export const onUpdateOverwatchViews = `${domain}/onUpdateOverwatchViews`
export const onUpdateOverwatchViewsSuccess = `${domain}/onUpdateOverwatchViewsSuccess`
export const onClearOverwatchFilters = `${domain}/onClearOverwatchFilters`